<template>
    <div id="product">
      <div class="general-header container">
        <h3 class="cate-title">{{name}}</h3>
        <div class="visible-xs" style="clear:both;"></div>

        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item >{{name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="product-box container">
        <ul class="product-list">
          <li v-for="item in childList" :key="item.id">
            <div class="box-img">
              <img :src="item.path" @click="checkDetail(item.id)" class="product-img hidden-xs" alt="">
              <img :src="item.path" @click="checkDetail(item.id)" class="product-img-m visible-xs" alt="">

            </div>
            <div class="pro-info">
              <div class="pro-t hidden-xs">
                <p @click="checkDetail(item.id)" class="pro-title">{{item.name}}</p>
                <p class="pro-model">{{item.model}}</p>
              </div>
              <div class="pro-t visible-xs">
                <p @click="checkDetail(item.id)" class="pro-title-m">{{item.name}}</p>
                <p class="pro-model-m">{{item.model}}</p>
              </div>
              <div class="pro-b hidden-xs">
                <p class="use-for" v-if="item.useFor">适用于：</p>
                <div class="pro-info" v-if="item.useFor">
                  {{item.useFor}}
                </div>
              </div>
              <div class="pro-b-m visible-xs">
                <p class="use-for" v-if="item.useFor">适用于：</p>
                <div v-if="item.useFor">
                  {{item.useFor}}
                </div>
              </div>
              <el-button @click="checkDetail(item.id)" class="hidden-xs hidden-sm">
                查看详情
              </el-button>
            </div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
    import Daily from '../../assets/data/goods-list.js';
    export default {
        name: "product",
      data(){
        return{
          name:'',
          kind:'',
          path:'',
          goodsList:[],
          childList:[],

        }
      },
      created() {
        this.filterKind()
      },
      watch: {
        $route(){
          this.filterKind()
        },
        value1:function (text) {
          this.$router.push({
            name: 'product',
            params:{
              id:text
            }
          })
        }
      },
      methods:{
        filterKind(){
          this.kind = this.$route.params.id;
          this.goodsList = Daily.goods;
          for(let i=0;i<this.goodsList.length;i++){
            if(this.goodsList[i].id === this.kind){
              this.childList = this.goodsList[i].child;
              this.name = this.goodsList[i].kind;
            }
          }
        },
        checkDetail(id){
          this.$router.push({
            name: 'product-detail',
            params:{
              id:id
            }
          })
        }
      }
    }
</script>

<style scoped lang="less">
  #product{
    .general-header{
      padding-top: 31px;
      padding-bottom: 31px;
      .cate-title{
        display: inline-block;
        width: 210px;
        margin:0;
        font-size: 26px;
      }
      .el-breadcrumb{
        padding: 0 10px;
        vertical-align: bottom;
        display: inline-block;
      }
    }
    .product-box{
      margin-bottom: 100px;
      padding-left: 0;
      padding-right: 0;
      .product-list{
        li{
          border: 1px solid transparent;
          transition: all 0.3s ease-in;
          padding: 20px 45px;
          display: flex;
          flex-direction: row;
          border-radius: 8px;
          margin-bottom: 20px;
          position: relative;
          .box-img{
            position: relative;
          }
          .product-img{
            width: 282px;
            height: 260px;
            margin-right: 100px;
          }
          .product-img-m{
            width: 150px;
            height: 150px;
            margin-right: 20px;
            margin-top: 20px;
          }
          .pro-info{
            font-size: 14px;
            position: relative;
            .pro-t{
              margin-bottom: 40px;
              .pro-title{
                cursor: pointer;
                font-size: 20px;
                margin-bottom: 6px;
                &:hover{
                  color:#004ca0;
                }
              }
              .pro-model{
                font-size: 16px;
                color:#999999;
              }
              .pro-title-m{
                font-weight: bold;
                font-size: 14px;
                margin: 0;
              }
              .pro-model-m{
                font-size: 12px;
                color:#cccccc;
              }
            }
            .pro-b{
              font-size: 14px;
              line-height: 18px;
              .use-for{
                font-weight: bold;
              }
            }
            .pro-b-m{
              font-size: 12px;
              .use-for{
                font-weight: bold;
              }
            }
            .el-button{
              transition: all 0.3s ease;
              height: 36px;
              position: absolute;
              left: 0;
              bottom: 26px;
            }

          }
        }
      }
    }
  }

</style>
<style scoped>
  .el-breadcrumb__inner{
    color:#aaaaaa!important;
    font-weight: 500!important;
  }
  @media (max-width: 868px) {
    #product .product-box .product-list li .product-img-m{
      margin-top: 0!important;
    }
    #main .inform .container .inform-style{
      width: 46%!important;
    }
    #product .product-box .product-list li{
      padding-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/product.vue